import utils from "../../assets/styles/utility.module.scss";

const setBold = (isBold: Boolean): string => {
  return isBold ? utils.font_bold : "";
};

export default setBold;
